import { render, staticRenderFns } from "./popover_content.vue?vue&type=template&id=d8518c82&scoped=true&lang=pug&"
import script from "./popover_content.vue?vue&type=script&lang=coffee&"
export * from "./popover_content.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8518c82",
  null
  
)

export default component.exports